import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipModule } from '../tooltip';
import { TextFieldComponent } from './text-field.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    TooltipModule
  ],
  declarations: [
    TextFieldComponent
  ],
  exports: [
    TextFieldComponent
  ]
})
export class TextFieldModule {
}
